import { createSelector } from '@ngrx/store';
import { getDragonflySharedState } from '../reducers';

export const getLiteralsState = createSelector(
  getDragonflySharedState,
  (state) => state.literals
);

export const getScreenSize = createSelector(
  getLiteralsState,
  ({ literals }) => literals
);
